(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-why-it-works"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.c-wiw__list').forEach(function (list) {
      var items = list.querySelectorAll('details.c-wiw__item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (item.open) {
            items.forEach(function (other) {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });
    });
  });

  // Re-bind on Shopify editor section reload
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    var list = section.querySelector('.c-wiw__list');
    if (!list) return;
    var items = list.querySelectorAll('details.c-wiw__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) other.removeAttribute('open');
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
